import { render, staticRenderFns } from "./Redirect.vue?vue&type=template&id=f041f5fc&scoped=true&lang=pug&"
import script from "./Redirect.vue?vue&type=script&lang=js&"
export * from "./Redirect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f041f5fc",
  null
  
)

export default component.exports